module.exports = __webpack_public_path__ + "img/4.c9a2ba45.png";